import { createContext, useContext, useEffect, useState } from "react";
import { db } from "../config/firebase";
import { doc, onSnapshot } from "firebase/firestore";

const CMSContext = createContext({});

const CMS_SECTIONS = [
  "hero",
  "categories",
  "features",
  "howItWorks",
  "faq",
  "pricing",
  "websiteListings",
];

export function CMSProvider({ children }) {
  const [cms, setCms] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let loadedCount = 0;

    // One real-time listener per section — updates instantly when admin saves
    const unsubscribers = CMS_SECTIONS.map((section) =>
      onSnapshot(
        doc(db, "cms", section),
        (snap) => {
          if (snap.exists()) {
            setCms((prev) => ({ ...prev, [section]: snap.data() }));
          }
          loadedCount++;
          if (loadedCount >= CMS_SECTIONS.length) setLoading(false);
        },
        (err) => {
          console.warn(`CMS section "${section}" unavailable:`, err.code);
          loadedCount++;
          if (loadedCount >= CMS_SECTIONS.length) setLoading(false);
        },
      ),
    );

    return () => unsubscribers.forEach((u) => u());
  }, []);

  return (
    <CMSContext.Provider value={{ cms, loading }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  return useContext(CMSContext);
}
